module.exports = __webpack_public_path__ + "resources/img/sp_tcc.7e03f5c9564d5ecbe1ebaea12bc31f8e.png";